module.exports = __webpack_public_path__ + "img/activity_finished.7a863277.png";